<section *ngIf="styles" class="section-banners" [ngStyle]="styles">
  <div id="carouselBanners" class="carousel slide" [attr.data-bs-ride]="carouselType == 'Dinâmico' ? 'carousel' : null"
    *ngIf="!!banners && banners.length > 0">
    <!-- Indicadores -->
    <ol class="carousel-indicators">
      <li *ngFor="let url of banners; let i = index" data-bs-target="#carouselBanners" [attr.data-bs-slide-to]="i"
        [class.active]="i === 0"></li>
    </ol>

    <!-- Itens do carrossel -->
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index" [class.active]="i === 0"
        [attr.data-bs-interval]="carouselInterval ? carouselInterval * 1000 : 5000">
        <a *ngIf="banner.link; else semLink" class="d-block" [href]="banner.link" target="_blank" rel="noopener noreferrer">
          <ng-container *ngTemplateOutlet="imagemBanner; context: { banner: banner, i: i }"></ng-container>
        </a>
        <ng-template #semLink>
          <ng-container *ngTemplateOutlet="imagemBanner; context: { banner: banner, i: i }"></ng-container>
        </ng-template>
      </div>
    </div>

    <!-- Controles -->
    <a *ngIf="banners.length > 1" class="carousel-control-prev" href="#carouselBanners" role="button"
      data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Anterior</span>
    </a>
    <a *ngIf="banners.length > 1" class="carousel-control-next" href="#carouselBanners" role="button"
      data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Próximo</span>
    </a>

    <ng-template #imagemBanner let-banner="banner" let-i="i">
      <div class="d-flex justify-content-center container banner-img">
        <img [src]="banner.url" alt="Banner {{ i }}" class="d-block w-100" />
      </div>
    </ng-template>
  </div>
</section>